import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IComponentOptions, IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {OppgaveRessurs, OppgavestatusBeregnet} from "felles/tjenester/ressurser/OppgaveRessurs";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {ModelloppdateringTjeneste} from "web/tjenester/ModelloppdateringTjeneste";
import {OppgaveTjenesteWeb} from "web/moduler/oppgave/OppgaveTjenesteWeb";
import {FavorittTjeneste} from "felles/tjenester/modulspesifikke/FavorittTjeneste";
import {RedigerOppgaveDialog} from "web/moduler/oppgave/modale/redigerOppgaveDialog/redigerOppgaveDialog";
import {OppgaveTjeneste} from "felles/tjenester/modulspesifikke/OppgaveTjeneste";
import {kopierFraAjsTilNg2} from "felles-ng2/modell/ajsNg2ModellBroer";
import {OppgaveModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {KommentarDatatjenesteForAjs} from "web/nedgraderteNg2Tjenester";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {ng2RegNavn} from "web/nedgraderteNg2TjenesterRegisternavn";

const css = require('./visOppgave.scss');


export function registrerVisOppgaveKomponent(angular: IModule) {
    angular
        .component('wmOppgaveListe', visOppgaveListeKomponentDef())
        .component('wmOppgaveVis', visOppgaveKomponentDef())
}

export function visOppgaveListeKomponentDef(): IComponentOptions {
    return {
        bindings: {oppgaver: "<", forelderId: "<", visForelder: '@', visEnlinjesBeskrivelse: '@'},
        controller: VisOppgaveListeKontroller.forInjisering(),
        template: require('./visOppgaveListe.html')
    };
}

export function visOppgaveKomponentDef(): IComponentOptions {
    return {
        bindings: {oppgave: "<"},
        require: {oppgaveListeKontroller: '^wmOppgaveListe'},
        controller: VisOppgaveKontroller.forInjisering(),
        template: require('./visOppgave.html')
    };
}

export class VisOppgaveListeKontroller implements IController {
    static forInjisering() {
        return [
            regNavn.ng.$scope,
            ModelloppdateringTjeneste.regNavn,
            MeldingTilBruker.regNavn,
            OppgaveRessurs.regNavn,
            regNavn.gettext.gettextCatalog,
            VisOppgaveListeKontroller
        ]
    }

    constructor(private $scope: IScope,
                private modelloppdatering: ModelloppdateringTjeneste,
                private meldingTilBruker: MeldingTilBruker,
                private oppgaveRessurs: OppgaveRessurs,
                private gettextCatalog: gettextCatalog) {
        this.lyttTilNyOppgave();
        this.lyttTilOppgaveOppdatert();
        this.lyttTilOppgaveSlettet();
    }

    oppgaver: l.OppgaveModell[]; //satt via bindings
    forelderId: string; //settes via bindings
    visForelder: 'true' | 'false'; //settes via bindings (undefined tolkes som true)
    visEnlinjesBeskrivelse: 'true' | 'false'; //settes via bindings (undefined tolkes som true)
    status: string; //satt via $onChanges

    $onChanges(changes: IOnChangesObject) {

    }

    // hjelpemetoder

    //modelloppdateringslyttere

    private lyttTilNyOppgave() {
        this.modelloppdatering.vedNyOppgave(
            oppgaveOgMøte => this.forelderId &&
                this.forelderId == oppgaveOgMøte.oppgaveForelderId &&
                !_(this.oppgaver).some({id: oppgaveOgMøte.oppgaveId}),
            this.$scope,
            oppgaveOgMøte => {
                this.oppgaveRessurs.hent(oppgaveOgMøte.oppgaveId).$promise.then(oppgave => {
                    if (_(this.oppgaver).some({id: oppgave.id})) return;
                    this.oppgaver.push(oppgave);
                    this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Ny oppgave registrert"));
                });
            });
    }

    private lyttTilOppgaveOppdatert() {
        this.modelloppdatering.vedOppdatertOppgave(
          oppgaveOgMøte => _(this.oppgaver).some({id: oppgaveOgMøte.oppgaveId}),
          this.$scope,
          oppgaveOgMøte => {
              this.oppgaveRessurs.hent(oppgaveOgMøte.oppgaveId).$promise.then(oppgave => {
                  this.oppgaver[_(this.oppgaver).findIndex({id: oppgave.id})] = oppgave;
                  this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Oppgave oppdatert"));
              });
          });
    }

    private lyttTilOppgaveSlettet() {
        this.modelloppdatering.vedSlettetOppgave(
            oppgaveOgMøte => _(this.oppgaver).some({id: oppgaveOgMøte.oppgaveId}),
            this.$scope,
            oppgaveOgMøte => {
                _.remove(this.oppgaver, {id: oppgaveOgMøte.oppgaveId});
                this.meldingTilBruker.infomelding(this.gettextCatalog.getString("Oppgave slettet"));
            });
    }

}

export class VisOppgaveKontroller implements IController {
    static forInjisering() {
        return [
            FavorittTjeneste.regNavn,
            OppgaveTjenesteWeb.regNavn,
            OppgaveTjeneste.regNavn,
            RedigerOppgaveDialog.regNavn,
            ng2RegNavn.KommentarDatatjenesteForAjs,
            VisOppgaveKontroller
        ]
    }

    constructor(private favorittTjeneste: FavorittTjeneste,
                private oppgaveTjenesteWeb: OppgaveTjenesteWeb,
                private oppgaveTjeneste: OppgaveTjeneste,
                private redigerOppgaveDialog: RedigerOppgaveDialog,
                private kommentarDatatjeneste: KommentarDatatjenesteForAjs) {
    }

    oppgaveListeKontroller: VisOppgaveListeKontroller; //satt via require

    oppgave: l.OppgaveModell; //satt via bindings
    ng2Oppgave: OppgaveModell; //satt via $onChanges
    status: string; //satt via $onChanges

    redigeringMulig = false;

    private kommentarerVises = false;

    visForelder() {
        return this.oppgaveListeKontroller.visForelder !== 'false';
    }

    visEnlinjesBeskrivelse() {
        return this.oppgaveListeKontroller.visEnlinjesBeskrivelse !== 'false' &&
            !_.isEmpty(this.oppgave.beskrivelse);
    }

    oppgavestatus() {
        return OppgaveRessurs.oppgaveStatus2(this.oppgave);
    }

    oppgavestatuser() {
        return OppgavestatusBeregnet;
    }

    rediger() {
        this.redigerOppgaveDialog.visRedigerOppgaveDialog(this.oppgave);
    }

    inverterUtfoertStatus() {
        this.oppgaveTjenesteWeb.inverterUtførtStatus(this.oppgave)
          .then(oppdatert => this.oppgave = oppdatert);
    }

    slett() {
        this.oppgaveTjenesteWeb.slett(this.oppgave);
    }

    toggleVisKommentarer() {
        this.kommentarerVises = !this.kommentarerVises;
    }

    erVisKommentarer() {
        return this.kommentarerVises;
    }

    erFavoritt() {
        return this.favorittTjeneste.erFavoritt(this.oppgave);
    }

    endreFavorittmarkering() {
        this.favorittTjeneste.endreFavorittmarkeringForOppgave(this.oppgave);
    }

    $onChanges(endringer: IOnChangesObject): void {
        dersomChangesInneholder(endringer, 'oppgave', () => {
            this.redigeringMulig = this.oppgaveTjeneste.kanOppgaveRedigeres(this.oppgave);

            this.ng2Oppgave = kopierFraAjsTilNg2(this.oppgave);
            //populer KommentarerDatatjeneste (for at <kommentarer-teller> og <oppgave-kommentarer> skal ha tilgang til data)
            this.kommentarDatatjeneste.tjeneste().then(kommentarerDatatjeneste =>
                kommentarerDatatjeneste.erstattILokallager(this.ng2Oppgave.kommentarer, this.ng2Oppgave.id));
        });
    }

    // hjelpemetoder

}
